import Page from '../../../enums/Page';
import {orderStatusPromisePoller, placeOrderViaApiPoller} from '../../api/pollers/pollers';
import {redirect} from '../../api/redirect';
import PaymentHelper from '../../order-processing/payment-helper';
import getPage from '../../page/getPage';
import doMetric from '../../tracking/bigQueryMetricRecorder';
import Track from '../../utils/tracking';
import {
  INITIATE_DEVICE_DATA_COLLECTION,
  UPDATE_SHOULD_SHOW_THREEDS_CHALLENGE_IFRAME,
  UPDATE_THREEDS_DATA_FOR_CHALLENGE_IFRAME,
} from '../action-types';
import {submitConfirmation, submitDeviceUpdates} from '../APIActions/CheckoutAPIActions';
import setDeviceDataCollectionComplete from './setDeviceDataCollectionComplete';
import {setPageMessage} from '../pageMessageActions';
import {startOrderProcessing, stopOrderProcessing} from '../site-actions';

export const setErrorOnPage = () => (dispatch) => {
  dispatch(stopOrderProcessing());
  dispatch(setPageMessage());
};

export const submitResult = (sessionId = '', threeDSMethodCompletion = null) => async (dispatch) => {
  const showOverlay = getPage() !== Page.PROCESSING;
  dispatch(setDeviceDataCollectionComplete());
  dispatch(startOrderProcessing(showOverlay));
  return dispatch(submitDeviceUpdates({fingerprint: sessionId, methodCompletion: threeDSMethodCompletion}))
    .then(placeOrderViaApiPoller.runPoller)
    .catch((err) => {
      Track.error(`Error when submitting result for 3DS: ${err}`);
      dispatch(setErrorOnPage());
    });
};

export const submitConfirm = (transactionID = null, shouldRedirect = false) => async (dispatch) => {
  const onOrderProcessing = getPage() === Page.PROCESSING;
  
  if (!onOrderProcessing) {
    dispatch(startOrderProcessing(true));
  }
  
  return dispatch(submitConfirmation({PaRes: transactionID}))
    .then(() => {
      if (!onOrderProcessing) {
        placeOrderViaApiPoller.runPoller();
        if (shouldRedirect) {
          redirect.doRedirect('/checkout/processing');
        }
      } else {
        orderStatusPromisePoller.runPoller()
          .then(response => PaymentHelper.processResponse(response))
          .then(redirectUrl => redirectUrl)
          .catch((error) => {
            Track.error(`Error processing order, redirecting for 3DS. ${error}`);
            redirect.doRedirect('/checkout');
          })
          .then((url) => {
            if (url !== 'QR_CODE' && url !== '3DS_REQUIRED') {
              redirect.doRedirect('/checkout/complete?app=express');
            }
          });
      }
    })
    .catch((err) => {
      Track.error(err);
      dispatch(setErrorOnPage());
    });
};

export const initiateDeviceDataCollection = threeDSecureData => ({
  type: INITIATE_DEVICE_DATA_COLLECTION,
  threeDSecureData,
});

export const updateShouldShowThreeDsChallengeIframe = shouldShow => ({
  type: UPDATE_SHOULD_SHOW_THREEDS_CHALLENGE_IFRAME,
  shouldShow,
});

const adyen3DSComplete = (endpoint, body) => (dispatch) => {
  dispatch(startOrderProcessing());
  
  placeOrderViaApiPoller
    .execPost(
      JSON.stringify(body),
      undefined,
      `/checkout-api/v2/${endpoint}`,
      'application/json',
    )
    .catch(() => {
      dispatch(setErrorOnPage());
    });
};

export const adyen3DSIdentifyComplete = threeDSCompInd => adyen3DSComplete('device-update', {
  fingerprint: threeDSCompInd,
});

export const adyen3DSChallengeComplete = transStatus => adyen3DSComplete('3ds-confirmation', {
  PaRes: transStatus,
});

export const recordBigQueryEvent = (type, provider, attributes = [], errors = []) => {
  try {
    doMetric(`threeDS${type}`, [{name: 'provider', value: provider}, ...attributes], errors, 'impression');
  } catch (error) {
    Track.track(error);
  }
};

export const updateThreeDSecureDataForChallengeIframe = threeDSecureData => ({
  type: UPDATE_THREEDS_DATA_FOR_CHALLENGE_IFRAME,
  threeDSecureData,
});
